import React from 'react';
import '../../styles/footer/footer.scss';

const Footer = () => {
    return(
        <section id='footer-layout'> 
            <footer id='footer'>
                <p id='left' className='footer-text'>Intern.house is not affiliated with the companies employing its tenants.</p>
                <p id='links' className='footer-text'>
                    <a href="mailto:brian@intern.house">brian@intern.house</a><span className='footer-divider'>|</span><a href="https://docs.google.com/forms/d/e/1FAIpQLSd7moqxKKxk7mP0K_rex3Giv5ngFi4f8qQ8rf81urZ-wY1U3A/viewform?usp=sf_link" target="_blank" rel="noopener noreferrer">Apply for Housing</a>
                </p>
                <p id='right' className='footer-text'>&copy; 2022-2026, Intern.House</p>
            </footer>
        </section>
    );
}


export default Footer;